import { jsxs as l, jsx as C } from "react/jsx-runtime";
const e = ({
  width: r,
  height: t,
  className: i
}) => /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    fill: "none",
    height: t,
    viewBox: "0 0 13 12",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_15632_2153)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M4.76857 10.4914C4.11714 10.2343 3.55143 9.84 3.08857 9.32571C2.26571 8.41714 1.83714 7.23429 1.83714 6.01714C1.83714 4.8 2.26571 3.61714 3.08857 2.70857C3.55143 2.19429 4.11714 1.8 4.76857 1.54286C5.11143 1.40571 5.14571 1.25143 5.16286 1.09714C5.18 0.908571 5.16286 0.531429 5.16286 0.377143C5.14571 0.0857143 5.09429 0 4.88857 0C4.88857 0 4.7 0.0514286 4.63143 0.0685714C3.41429 0.497143 2.38571 1.28571 1.64857 2.34857C0.911429 3.41143 0.5 4.66286 0.5 6C0.5 7.33714 0.911429 8.58857 1.64857 9.65143C2.38571 10.7143 3.41429 11.5029 4.63143 11.9314C4.7 11.9486 4.83714 12 4.88857 12C5.09429 12 5.14571 11.9143 5.16286 11.6571C5.16286 11.5029 5.18 11.1257 5.16286 10.9371C5.16286 10.7829 5.11143 10.6286 4.76857 10.4914Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M8.2144 10.4914C8.86583 10.2343 9.43155 9.84 9.89441 9.32571C10.7173 8.41714 11.1458 7.23429 11.1458 6.01714C11.1458 4.8 10.7173 3.61714 9.89441 2.70857C9.43155 2.19429 8.86583 1.8 8.2144 1.54286C7.87155 1.40571 7.83726 1.25143 7.82012 1.09714C7.80298 0.908571 7.82012 0.531429 7.82012 0.377143C7.83726 0.0857143 7.88869 0 8.0944 0C8.0944 0 8.28298 0.0514286 8.35155 0.0685714C9.56869 0.497143 10.5973 1.28571 11.3344 2.34857C12.0715 3.41143 12.4658 4.66286 12.483 6C12.483 7.33714 12.0715 8.58857 11.3344 9.65143C10.5973 10.7143 9.56869 11.5029 8.35155 11.9314C8.28298 11.9486 8.14583 12 8.0944 12C7.88869 12 7.83726 11.9143 7.82012 11.6571C7.82012 11.5029 7.80298 11.1257 7.82012 10.9371C7.82012 10.7829 7.87155 10.6286 8.2144 10.4914Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M7.04855 5.38286L6.51712 5.26286C6.29427 5.21143 6.08855 5.17715 5.88284 5.09143C5.67712 5.02286 5.57427 4.85143 5.59141 4.57715C5.59141 4.38857 5.65998 4.14857 5.91712 4.08C6.08855 4.02857 6.29427 3.99429 6.53427 3.99429C6.92855 3.99429 7.16855 4.18286 7.30569 4.56C7.37427 4.74857 7.42569 4.86857 7.75141 4.86857L8.40284 4.83429C8.60855 4.83429 8.71141 4.68 8.64284 4.40572C8.43712 3.58286 7.87141 3.03429 7.13427 2.86286V2.17715C7.13427 1.98857 7.13427 1.8 6.80855 1.8H6.05427C5.86569 1.8 5.77998 1.92 5.77998 2.09143V2.86286C5.33427 2.94857 4.93998 3.17143 4.66569 3.48C4.35712 3.84 4.20284 4.30286 4.23712 4.83429C4.30569 5.77715 5.19712 6.20572 5.40284 6.27429C5.59141 6.32572 5.76284 6.37715 5.95141 6.41143L6.48284 6.53143C6.70569 6.58286 6.91141 6.61715 7.11712 6.70286C7.32284 6.77143 7.42569 6.94286 7.40855 7.21715C7.40855 7.40572 7.33998 7.64572 7.08284 7.71429C6.91141 7.76572 6.70569 7.8 6.46569 7.8C6.07141 7.8 5.83141 7.61143 5.69427 7.23429C5.62569 7.04572 5.57427 6.92572 5.24855 6.92572L4.59712 6.96C4.39141 6.96 4.28855 7.11429 4.35712 7.38857C4.56284 8.21143 5.12855 8.76 5.86569 8.93143V9.61715C5.86569 9.80572 5.86569 9.99429 6.19141 9.99429H6.94569C7.13427 9.99429 7.21998 9.87429 7.21998 9.70286V8.93143C7.66569 8.84572 8.05998 8.62286 8.33427 8.31429C8.64284 7.95429 8.79712 7.49143 8.76284 6.96C8.72855 6.56572 8.64284 5.64 7.06569 5.38286H7.04855Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_15632_2153", children: /* @__PURE__ */ C(
        "rect",
        {
          fill: "currentColor",
          height: "12",
          transform: "translate(0.5)",
          width: "12"
        }
      ) }) })
    ]
  }
);
export {
  e as Content
};
